import React from "react";
import { Link } from "react-router-dom";
import "./eventoCard.css";

const EventoCard = ({ img, titulo, fecha, descripcion, link }) => {
  return (
    <div className="evento-card">
      <img src={img} alt={titulo} className="evento-img" />

      <div className="evento-body">
        <h3 className="evento-titulo">{titulo}</h3>
        <span className="evento-fecha">{fecha}</span>
        <p className="evento-desc">{descripcion}</p>

        <Link to={link} className="evento-btn">Ver más...</Link>
        
      </div>
    </div>
  );
};

export default EventoCard;
